class CollapsibleContent {
  constructor() {
    this.init();
  }

  init() {
    document.querySelectorAll('.collapsible-trigger').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !isExpanded);
        const content = trigger.nextElementSibling;
        content.style.display = isExpanded ? 'none' : 'block';
      });
    });
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('collapsible-content')) {
  customElements.define('collapsible-content', class extends HTMLElement {
    connectedCallback() {
      new CollapsibleContent();
    }
  });
}